import { createModal } from '/@/core/elements/modal'

interface EditImageModalData {
  imageId: string
}

const { api, component } = createModal<EditImageModalData>(
  'EditImageModal',
  () => import('./EditImageModal.vue'),
  {
    imageId: '',
  },
)

export const useEditImageModal = api
export default component
